<template>
  <v-flex shrink>
    <v-confirmation-dialog
      @confirm="remove"
      :text="`¿Estás seguro que quieres eliminar el atributo '${feature.name}'?`"
    >
      <template #activator="{ on }">
        <v-btn v-on="on" @click.stop class="btn-clear" icon :loading="feature.removing">
          <v-icon small>clear</v-icon>
        </v-btn>
      </template>
    </v-confirmation-dialog>
  </v-flex>
</template>

<script>
import VConfirmationDialog from "@/components/confirmations/ConfirmationDialog.vue";

export default {
  components: {
    VConfirmationDialog
  },
  props: {
    /**
     * The feature to show in the hader.
     */
    feature: {
      type: Object,
      required: true
    }
  },
  methods: {
    /**
     * Remove the feature identified by its id from the active classification.
     */
    remove() {
      this.$store.dispatch("ner/removeFeature", this.feature.id).catch(() => {
        this.$notify.error(
          "Lo siento, tuvimos un problema. Por favor vuelve a intentar en unos minutos."
        );
      });
    }
  }
};
</script>

<style scoped>
.btn-clear {
  margin: 0;
  color: rgba(0, 0, 0, 0.3);
}

.btn-clear:hover {
  color: rgba(0, 0, 0);
}
</style>